import { getColors } from "../../../jss_setup/colors";

export const footer = {
  footer: {
    background: getColors().base_color,
    smallscreen: {
      gridTemplateColumns: "repeat(4, max-content)",
      justifyContent: "space-evenly",
    },
  },
  quickLinksHeader: {
    display: "none",
  },
  quickLinkLabel: {
    textTransform: "uppercase",
  },
};
